<template>
	<Container>
		<Loader v-if="isLoading"></Loader>
		<h2 v-else class="mb-4 font-bold">{{ $t('user_massive_registration') }}</h2>
		<div class="mb-4">
			<div class="mb-4">
				<label class="block mb-2 font-bolder" for="category_name">{{ $t('user_list') }}:</label>
				<span class="block" v-if="file">{{ file.name }}</span>
				<input id="file" class="inputfile" type="file" accept=".csv" @change="file_upload" />
				<label for="file">{{ $t('selected_file') }}</label>
				<button class="bg-secondary text-white border-0 rounded-sm p-2 ml-2 mt-2 shadow-md outline-none cursor-pointer hover:text-primary focus:outline-none" @click.prevent="file_reset">
					{{ $t('delete_file') }}
				</button>
				<a href="/docs/template.csv" target="_blank">
					<button class="bg-secondary text-white border-0 rounded-sm p-2 ml-2 mt-2 shadow-md outline-none cursor-pointer hover:text-primary focus:outline-none">
						{{ $t('download_template') }}
					</button>
				</a>
				<p class="text-sm mt-2">{{ $t('csv_text') }}</p>
				<div v-if="$v.file.$dirty">
					<div class="text-sm text-red-500 mt-2" v-if="!$v.file.required">
						{{ $t('file_required') }}
					</div>
				</div>
			</div>
			<div v-if="finished" class="mt-3">
				<p class="text-xs text-red-500">{{ $t('Nota') }}:</p>
				<li class="text-xs" v-html="alert + ' :'"></li>
				<span class="text-xs">{{ list_users }}</span>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="onUploadFile()" v-if="!finished">
					<div v-if="loading">
						<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
					</div>
					<div v-else>
						{{ $t('send') }}
					</div>
				</ButtonBlack>
				<router-link to="listado/usuarios" v-else>
					<ButtonBlack class="mt-4">
						{{ $t('finish') }}
					</ButtonBlack>
				</router-link>
			</div>

			<Loader v-if="isLoading"></Loader>
		</div>
	</Container>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ButtonBlack from '@/components/ButtonBlack'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
	data() {
		return {
			isLoading: false,
			endpoint: 'upload_user_file',
			file: null,
			section: 'usuarios',
			loading: false,
			error: false,
			server_error: null,
			finished: false,
			alert: null,
			list_users: null,
		}
	},
	created() {},
	methods: {
		onUploadFile() {
			let bodyFormData = new FormData()
			bodyFormData.append('users', this.file)
			this.loading = true
			this.error = false
			this.finished = false
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$axios
					.post(`/${this.endpoint}`, bodyFormData)
					.then(res => {
						this.$axios('/send-password')
						this.loading = false
						if (!res.data.data.usuarios) {
							setTimeout(this.$router.push(`/admin/listado/${this.section}`), 2000)
						} else {
							this.finished = true
							this.alert = res.data.data.message
							this.list_users = res.data.data.usuarios.join(', ')
						}
					})
					.catch(err => {
						if (err.response.status === 401) {
							this.$store.dispatch('login/logout')
						}
						let error_list = err.response.data.data.message
						this.setError(error_list)
					})
			} else {
				let error_list = this.$t('form_validation')
				this.setError(error_list)
			}
		},
		file_reset() {
			this.file = null
		},
		file_upload(event) {
			if (event.target.files.length > 0) {
				this.file = event.target.files[0]
			}
		},
		setError(error_list) {
			this.loading = false
			this.error = true
			this.server_error = error_list
		},
	},
	components: {
		ButtonBlack,
		PulseLoader,
	},
	validations() {
		return {
			file: {
				required,
			},
		}
	},
}
</script>
